const config = {
  requestParams: {
    _productId: '21000040',
    _version: '1.0.0',
  },
  BizKey: 'metis.flying.customer.web',
  BizKeyConfig: {
  },
  CAID: 0,
}

export default config
